module.exports = __webpack_public_path__ + "img/icon-t.4dc25735.png";